import { ESSENTIAL_TOOLS_IDS } from './EssentialTools.enum';

/**
 * Ordem fixa (esquerda → direita) para desempate dentro do mesmo grupo
 * (não ativado no topo, ativado no final).
 */
export const ESSENTIAL_TOOLS_DISPLAY_ORDER = [
  ESSENTIAL_TOOLS_IDS.DOMAIN,
  ESSENTIAL_TOOLS_IDS.EMAIL,
  ESSENTIAL_TOOLS_IDS.GATOR_PROTECT,
  ESSENTIAL_TOOLS_IDS.LINK_IN_BIO,
  ESSENTIAL_TOOLS_IDS.SITE_LOCK,
  ESSENTIAL_TOOLS_IDS.SITE_BUILDER,
];

function displayOrderIndex(id) {
  const i = ESSENTIAL_TOOLS_DISPLAY_ORDER.indexOf(id);
  return i === -1 ? Number.MAX_SAFE_INTEGER : i;
}

/**
 * @param {Array<{ id: number }>} cards
 * @param {Record<number, object>} cardsActions
 * @param {Record<number, boolean>} activationById — true = produto já contratado/ativado
 */
export function sortEssentialToolCards(cards, cardsActions, activationById = {}) {
  return [...cards]
    .filter(card => cardsActions[card.id])
    .sort((a, b) => {
      const actA = activationById[a.id] ? 1 : 0;
      const actB = activationById[b.id] ? 1 : 0;
      if (actA !== actB) {
        return actA - actB;
      }
      return displayOrderIndex(a.id) - displayOrderIndex(b.id);
    });
}
